export default __webpack_public_path__ + "static/media/Weak.6dbd150e.svg";